import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { incrementTic, incrementRequestsCnt } from '../redux/slices/ticSlice';

const Tic = () => {
  const dispatch = useDispatch();
  const tic = useSelector((state) => state.tic.tic);
  const [localTic, setLocalTic] = React.useState(0);

  React.useEffect(() => {
    // Создаем интервал, который будет выполняться каждую секунду
    const interval = setInterval(() => {
      dispatch(incrementTic());
    }, 1000);

    // Очищаем интервал при размонтировании компонента
    return () => {
      clearInterval(interval);
    };
  }, []);

  React.useEffect(() => {
    setLocalTic(localTic + 1);
  }, [tic]);

  React.useEffect(() => {
    // логика отправки запроса на сервер
    const tic_request_value = 15;
    if (localTic >= tic_request_value) {
      setLocalTic(0);
      dispatch(incrementRequestsCnt());
    }
  }, [localTic, dispatch]);

  // Компонент не рендерит ничего видимого
  return null;
};

export default Tic;
